import Icon from "@ant-design/icons";
import { useSelector } from "react-redux";

const CourthouseSVG = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const predefinedSizes = {
    small: { ...themeValue?.fontSmlSize?.size },
    medium: { ...themeValue?.fontMediumSize?.size },
    large: { ...themeValue?.fontLgSize?.size },
  };
  const { size, width, height } = props;
  const finalSize = predefinedSizes[size] || { width, height };

  return (
    <svg
      width={finalSize.width || "24"}
      height={finalSize.height || "24"}
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M21 21.75H1C0.59 21.75 0.25 21.41 0.25 21C0.25 20.59 0.59 20.25 1 20.25H21C21.41 20.25 21.75 20.59 21.75 21C21.75 21.41 21.41 21.75 21 21.75Z"
        fill="currentColor"
      />
      <path
        d="M13.5 5.22993C12.56 5.22993 11.62 5.04995 10.72 4.68995C10.44 4.57995 10.25 4.29994 10.25 3.98994V0.989941C10.25 0.739941 10.37 0.509946 10.58 0.369946C10.79 0.229946 11.05 0.199929 11.28 0.289929C12.71 0.859929 14.29 0.859929 15.72 0.289929C15.95 0.199929 16.21 0.229946 16.42 0.369946C16.63 0.509946 16.75 0.739941 16.75 0.989941V3.98994C16.75 4.29994 16.56 4.56995 16.28 4.68995C15.38 5.04995 14.44 5.22993 13.5 5.22993ZM11.75 3.46992C12.89 3.81992 14.11 3.81992 15.25 3.46992V2.01997C14.1 2.29997 12.9 2.29997 11.75 2.01997V3.46992Z"
        fill="currentColor"
      />
      <path
        d="M11 7.75C10.59 7.75 10.25 7.41 10.25 7V4C10.25 3.59 10.59 3.25 11 3.25C11.41 3.25 11.75 3.59 11.75 4V7C11.75 7.41 11.41 7.75 11 7.75Z"
        fill="currentColor"
      />
      <path
        d="M19 21.75H3C2.59 21.75 2.25 21.41 2.25 21V10C2.25 7.58 3.58 6.25 6 6.25H16C18.42 6.25 19.75 7.58 19.75 10V21C19.75 21.41 19.41 21.75 19 21.75ZM3.75 20.25H18.25V10C18.25 8.42 17.58 7.75 16 7.75H6C4.42 7.75 3.75 8.42 3.75 10V20.25Z"
        fill="currentColor"
      />
      <path
        d="M18.4201 11.75H3.58008C3.17008 11.75 2.83008 11.41 2.83008 11C2.83008 10.59 3.17008 10.25 3.58008 10.25H18.4201C18.8301 10.25 19.1701 10.59 19.1701 11C19.1701 11.41 18.8301 11.75 18.4201 11.75Z"
        fill="currentColor"
      />
      <path d="M7.74023 11H6.24023V21H7.74023V11Z" fill="currentColor" />
      <path d="M11.7402 11H10.2402V21H11.7402V11Z" fill="currentColor" />
      <path d="M15.7402 11H14.2402V21H15.7402V11Z" fill="currentColor" />
    </svg>
  );
};
const Courthouse = (props) => {
  const themeDefault = useSelector((state) => state.themeDefault);
  let themeValue = themeDefault?.info?.newConfig;
  const { size, color } = props;
  const predefinedSizes = {
    small: themeValue?.fontSmlSize,
    medium: themeValue?.fontMediumSize,
    large: themeValue?.fontLgSize,
  };
  return (
    <Icon
      component={CourthouseSVG}
      style={{
        fontSize: predefinedSizes[size] || predefinedSizes.medium,
      }}
      {...props}
    />
  );
};

export default Courthouse;
